import { NoDataMatchStyles } from '../../assets/styles/CommonStyles';
import {
    React,
    DataGrid,
    Tooltip,
    GridColDef,
    Box
} from '../../utils/globalImports';

import {
    CustomConfirmDialog,
    validationMessages
} from '../../utils/globalImports';


interface ModalProps {
    rows: any;
    columns: any;
    setRowHeigt?: boolean;
    isDialogOpen?: boolean;
    isToggleOn?: boolean;
    actionName?: string;
    handleCancel?: () => void;
    handleConfirm?: () => void;
    onRowClick?: (params: any) => void;
    customMessage?: string | ''
    tableStyling?: any,
    setHeight?: string
}


const CustomDataGrid: React.FC<ModalProps> = ({ rows, columns, setRowHeigt, isDialogOpen, isToggleOn, actionName, setHeight, handleCancel, handleConfirm, onRowClick, customMessage }) => {

    // Enhance columns to wrap long text values in a tooltip
    const enhancedColumns: GridColDef[] = columns.map((col: { renderCell: any; }) => {
        // Only apply for text-based fields with no custom render already defined
        if (!col.renderCell) {
            return {
                ...col,
                renderCell: (params: { value: string; }) => {
                    const value = params.value ?? '';
                    const isLong = typeof value === 'string' && value.length > 40;
                    const displayValue = isLong ? value.slice(0, 40) + '...' : value;
                    const tooltipText = isLong ? value.slice(0, 500) + (value.length > 500 ? '...' : '') : '';

                    return (
                        <Tooltip title={tooltipText} arrow placement="right-start"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        maxWidth: 600, // Or any desired width
                                        whiteSpace: 'pre-wrap', // Allows multiline
                                        fontSize: '14px',       // Optional styling
                                    },
                                },
                            }}>
                            <span style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                {displayValue}
                            </span>
                        </Tooltip>
                    );
                },
            };
        }
        return col;
    });


    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", minHeight: 0, width: "100%"}}>
                <DataGrid
                    rows={rows}
                    columns={enhancedColumns}
                    getRowId={(row) => row.id}
                    onRowClick={onRowClick}
                    getRowClassName={(params) =>
                        params.row.isBaselineComment ? 'highlight-row' : ''
                    }
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 5,
                            },
                        },
                    }}
                    sx={{
                        // maxHeight: setHeight || 450,
                        // overflowY: 'auto',
                        '& .MuiDataGrid-columnHeaders': {
                            borderBottom: "2px solid #e0e0e0",
                            backgroundColor: "#f5f8ff",
                        },

                        "& .MuiDataGrid-columnHeader": {
                            padding: "0 16px",
                            fontWeight: 700,
                            fontSize: "14px",
                            color: "#1e66ab",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                        },
                        "& .MuiDataGrid-cell:focus": {
                            outline: "none",
                        },
                        "& .MuiDataGrid-columnSeparator": {
                            display: "none !important",
                        },
                        "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
                            outline: "none",
                        },
                        
                        // "& .MuiDataGrid-overlay": {
                        //     color: "#1e66ab !important",
                        // },
                        // "& .MuiDataGrid": {
                        //     overflowY: "500px"
                        // },

                        '& .MuiDataGrid-cell': {
                            fontSize: '14px',
                            minHeight: 50,
                            color: '#1e66ab',

                            textAlign: (setRowHeigt ? 'left' : 'center'),
                            justifyContent: (setRowHeigt ? 'left' : 'center'),
                            display: 'flex',
                            alignItems: (setRowHeigt ? 'top' : 'center'),
                            whiteSpace: 'normal',   // allow wrapping if multiline
                            borderBottom: "1px solid #f0f0f0",
                        },
                        "& .MuiDataGrid-row": {
                            borderLeft: "4px solid transparent",
                            backgroundColor: "white",
                            boxSizing: "border-box",
                            cursor: "pointer",
                            transition: "background-color 0.15s ease",
                        },
                        // '& .highlight-row': {
                        //     backgroundColor: '#ffe5e5',
                        //     fontWeight: 'bold',
                        //     '&:hover': {
                        //         backgroundColor: '#ffe5e5 !important', // keep same red color on hover
                        //     },
                        // },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#f0f4ff",
                            borderLeft: "4px solid #1e66ab33",
                        },

                        /* ── Selected row ── */
                        "& .MuiDataGrid-row.Mui-selected": {
                            backgroundColor: "rgba(150, 193, 33, 0.10) !important",
                            borderLeft: "4px solid #96c121",
                        },

                        // "& .MuiDataGrid-row.Mui-selected:hover": {
                        //     backgroundColor: "rgba(150, 193, 33, 0.18) !important",
                        // },
                        "& .MuiDataGrid-footerContainer": {
                            color: "#1e66ab",
                            borderTop: "2px solid #e0e0e0",
                            backgroundColor: "#f5f8ff",
                            minHeight: "52px",
                        },
                        "& .MuiDataGrid-overlay": {
                        ...NoDataMatchStyles,

                        fontFamily: "'Poppins', sans-serif",
                        height: '100%', 
                        },



                    }}
                    getRowHeight={() => 'auto'}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    
                    localeText={{
                        noRowsLabel: customMessage || "No rows",
                    }}
                />
            </Box>


            {isDialogOpen && (
                <CustomConfirmDialog
                    open={isDialogOpen}
                    title={validationMessages.common_toggletitle(actionName === 'Contact'
                        ? isToggleOn
                            ? 'Deactivate' : 'Activate'
                        :
                        'Delete',
                        actionName!
                    )}
                    message={
                        validationMessages.common_toggleConfirm(actionName === 'Contact'
                            ? isToggleOn
                                ? 'Deactivate' : 'Activate'
                            :
                            'Delete',
                            actionName!
                        )
                    }
                    onConfirm={() => handleConfirm?.()}
                    onCancel={() => handleCancel?.()}
                    onClose={() => handleCancel?.()}
                />
            )}
        </>

    );

}

export default CustomDataGrid;